// removed by extract-text-webpack-plugin
module.exports = {"container":"_1bDLc9P6WdNsd-U863T9nm","item":"_1PwGfzwWVLiGsY0dASN9Pl"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/diary/pages/HappinessSubmitterPage.scss
// module id = 660
// module chunks = 0